import { Injectable } from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})

export class CustomErrorHandler {

  constructor(
    private snackBar: MatSnackBar
  ) {}

  handleError(error: any) {
    if(error?.error?.message && typeof(error?.error?.message) == 'string') {
      this.showMessage(error?.error?.message, 'error');
    }
    else if(error?.message && typeof(error?.message) == 'string') {
      this.showMessage(error?.message, 'error');
    }
    else if(typeof(error) == 'string') {
      this.showMessage(error, 'error');
    }
  }

  showMessage(message: string, messageType: 'success' | 'error') {
    this.snackBar.open(
      message,
      "Dismiss",
      {
          duration: 3000,
          panelClass: [messageType == 'error' ? 'error-snackbar' : 'success-snackbar']
      }
    );
  }

}